import React from 'react'
import classNames from 'classnames'
import './index.less'

export declare interface RadioProps {
  /**
   * 容器label层样式名
   */
  className?: string;
  /**
   * 容器label层行内样式
   */
  style?: React.CSSProperties;
  /**
   * 切换事件
   */
  onChange?:any;
  /**
   * 禁用
   */
  disabled?: boolean;
  children?: React.ReactNode;
  checked?: boolean;
  prefixClass?: string;
  onClick?: React.MouseEventHandler;
}

const Radio = (props: RadioProps) => {
  const {
    disabled,
    checked,
    onChange,
    onClick,
    children,
    className,
    style,
    prefixClass,
  } = props

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={classNames(`${prefixClass}RadioWrap`, className, {
        [`${prefixClass}RadioWrap--disabled`]: disabled,
        [`${prefixClass}RadioWrap--checked`]: checked,
      })}
      style={style}
      onClick={onClick}
    >
      <span className={`${prefixClass}Radio`}>
        <input
          className={`${prefixClass}RadioInput`}
          type="radio"
          disabled={disabled}
          checked={checked}
          onChange={(ev) => {
            onChange?.({
              value: ev.target.checked,
              event: ev,
              target: ev.target,
            })
          }}
        />
        <svg
          className={`${prefixClass}RadioIcon`}
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12" />
          <path
            className={`${prefixClass}RadioIconPath`}
            d="M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
          />
        </svg>
      </span>
      {children && (
        <span className={`${prefixClass}RadioLabel`}>{children}</span>
      )}
    </label>
  )
}

Radio.defaultProps = {
  disabled: false,
  checked: false,
  prefixClass: 'yk',
}

export default Radio
